import React from 'react'
import { Shield, AlertTriangle, RefreshCw, Mail, CheckCircle, AlertCircle, FileText } from "lucide-react"


const terminosYCondiciones = () => {
  return (
    // <div className="min-h-screen bg-gradient-to-br from-white to-green-50 py-12 px-4">
    //   <div className="max-w-4xl mx-auto">
    //     <div className="text-center mb-8">
    //       <div className="inline-flex items-center gap-2 mb-4">
    //         <Shield className="h-8 w-8" style={{ color: "#77c593" }} />
    //         <h1 className="text-4xl font-bold text-gray-900">Términos y Condiciones</h1>
    //       </div>
    //       <p className="text-xl text-gray-600 mb-4">mayma_wsp_API</p>
    //       <span
    //         className="inline-block px-3 py-1 text-sm border rounded-full"
    //         style={{ borderColor: "#77c593", color: "#77c593" }}
    //       >
    //         Última actualización: [completá con la fecha]
    //       </span>
    //     </div>

    //     <div className="space-y-6">
    //       {/* Sección 1: Uso del servicio */}
    //       <div className="bg-white rounded-lg shadow-lg p-6">
    //         <div className="flex items-center gap-3 mb-4">
    //           <CheckCircle className="h-6 w-6" style={{ color: "#77c593" }} />
    //           <h2 className="text-xl font-semibold text-gray-800">1. Uso del servicio</h2>
    //         </div>
    //         <div className="space-y-4">
    //           <p className="text-gray-700 leading-relaxed">
    //             El uso de{" "}
    //             <span className="font-semibold" style={{ color: "#77c593" }}>
    //               mayma_wsp_API
    //             </span>{" "}
    //             está destinado exclusivamente para clientes autorizados.
    //           </p>
    //           <div className="border-l-4 p-4 rounded-r-lg bg-red-50" style={{ borderLeftColor: "#ef4444" }}>
    //             <p className="font-medium text-red-800 mb-2">No está permitido utilizar el servicio para:</p>
    //             <ul className="space-y-2 text-red-700">
    //               <li className="flex items-center gap-2">
    //                 <div className="w-2 h-2 bg-red-400 rounded-full"></div>
    //                 Envío de spam o contenido no solicitado
    //               </li>
    //               <li className="flex items-center gap-2">
    //                 <div className="w-2 h-2 bg-red-400 rounded-full"></div>
    //                 Actividades ilegales
    //               </li>
    //               <li className="flex items-center gap-2">
    //                 <div className="w-2 h-2 bg-red-400 rounded-full"></div>
    //                 Suplantación de identidad
    //               </li>
    //             </ul>
    //           </div>
    //         </div>
    //       </div>

    //       {/* Sección 2: Responsabilidad */}
    //       <div className="bg-white rounded-lg shadow-lg p-6">
    //         <div className="flex items-center gap-3 mb-4">
    //           <AlertTriangle className="h-6 w-6 text-amber-600" />
    //           <h2 className="text-xl font-semibold text-gray-800">2. Responsabilidad</h2>
    //         </div>
    //         <div className="border p-4 rounded-lg bg-green-50" style={{ borderColor: "#77c593" }}>
    //           <p className="text-gray-700 leading-relaxed">
    //             <span className="font-semibold" style={{ color: "#77c593" }}>
    //               mayma_wsp_API
    //             </span>{" "}
    //             no se hace responsable por el mal uso del servicio o por errores derivados de información incorrecta
    //             proporcionada por el usuario.
    //           </p>
    //         </div>
    //       </div>

    //       {/* Sección 3: Cambios en los términos */}
    //       <div className="bg-white rounded-lg shadow-lg p-6">
    //         <div className="flex items-center gap-3 mb-4">
    //           <RefreshCw className="h-6 w-6" style={{ color: "#77c593" }} />
    //           <h2 className="text-xl font-semibold text-gray-800">3. Cambios en los términos</h2>
    //         </div>
    //         <p className="text-gray-700 leading-relaxed">
    //           Nos reservamos el derecho de modificar estos términos en cualquier momento. Las actualizaciones serán
    //           publicadas en este sitio.
    //         </p>
    //       </div>

    //       {/* Sección 4: Soporte */}
    //       <div className="bg-white rounded-lg shadow-lg p-6">
    //         <div className="flex items-center gap-3 mb-4">
    //           <Mail className="h-6 w-6" style={{ color: "#77c593" }} />
    //           <h2 className="text-xl font-semibold text-gray-800">4. Soporte</h2>
    //         </div>
    //         <div className="border p-4 rounded-lg bg-green-50" style={{ borderColor: "#77c593" }}>
    //           <p className="text-gray-700 leading-relaxed">
    //             Para consultas o soporte técnico, puede escribirnos a:{" "}
    //             <a
    //               href="mailto:maymasistemas@gmail.com"
    //               className="font-semibold hover:underline transition-colors underline decoration-2 underline-offset-2"
    //               style={{ color: "#77c593" }}
    //             >
    //               maymasistemas@gmail.com
    //             </a>
    //           </p>
    //         </div>
    //       </div>
    //     </div>

    //     {/* Separador */}
    //     <div className="border-t border-gray-200 my-8"></div>

    //     <div className="text-center text-sm text-gray-500">
    //       <p>© 2024 mayma_wsp_API. Todos los derechos reservados.</p>
    //     </div>
    //   </div>
    // </div>
        <div className="min-h-screen bg-gray-50 py-16 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header empresarial */}
        <div className="bg-white border border-gray-200 rounded-lg mb-8 p-8">
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-3">
              <div className="p-2 rounded-lg" style={{ backgroundColor: "#f0fdf4" }}>
                <Shield className="h-6 w-6" style={{ color: "#77c593" }} />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-gray-900">Términos y Condiciones de Servicio</h1>
                <p className="text-gray-600 mt-1">Mayma</p>
              </div>
            </div>
          </div>
        </div>

        {/* Contenido principal */}
        <div className="bg-white border border-gray-200 rounded-lg">
          <div className="p-8">
            {/* Sección 1 */}
            <section className="mb-8">
              <div className="flex items-center gap-3 mb-4 pb-2 border-b border-gray-100">
                <FileText className="h-5 w-5 text-gray-600" />
                <h2 className="text-lg font-semibold text-gray-900">1. Alcance y Uso del Servicio</h2>
              </div>
              <div className="ml-8 space-y-4">
                <p className="text-gray-700 leading-relaxed">
                  El servicio de{" "}
                  <span className="font-medium" style={{ color: "#77c593" }}>
                    Mayma
                  </span>{" "}
                  está destinado exclusivamente para uso comercial por parte de clientes debidamente autorizados y
                  registrados.
                </p>

                <div className="bg-red-50 border-l-4 border-red-400 p-4 my-4">
                  <div className="flex items-start gap-2">
                    <AlertCircle className="h-5 w-5 text-red-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <h4 className="font-medium text-red-800 mb-2">Usos Prohibidos</h4>
                      <ul className="text-red-700 space-y-1 text-sm">
                        <li>• Envío de comunicaciones no solicitadas (spam)</li>
                        <li>• Actividades que contravengan la legislación vigente</li>
                        <li>• Suplantación de identidad o representación fraudulenta</li>
                        <li>• Uso que pueda comprometer la integridad del sistema</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* Sección 2 */}
            <section className="mb-8">
              <div className="flex items-center gap-3 mb-4 pb-2 border-b border-gray-100">
                <AlertCircle className="h-5 w-5 text-gray-600" />
                <h2 className="text-lg font-semibold text-gray-900">2. Limitación de Responsabilidad</h2>
              </div>
              <div className="ml-8 space-y-4">
                <p className="text-gray-700 leading-relaxed">
                  <span className="font-medium" style={{ color: "#77c593" }}>
                    Mayma
                  </span>{" "}
                  actúa como proveedor de servicios tecnológicos y no asume responsabilidad por:
                </p>
                <ul className="text-gray-700 space-y-2 ml-4">
                  <li>• El uso indebido del servicio por parte del cliente</li>
                  <li>• Errores derivados de información incorrecta proporcionada por el usuario</li>
                  <li>• Interrupciones del servicio por causas de fuerza mayor</li>
                  <li>• Daños indirectos o consecuenciales</li>
                </ul>
              </div>
            </section>

            {/* Sección 3 */}
            <section className="mb-8">
              <div className="flex items-center gap-3 mb-4 pb-2 border-b border-gray-100">
                <RefreshCw className="h-5 w-5 text-gray-600" />
                <h2 className="text-lg font-semibold text-gray-900">3. Modificaciones de los Términos</h2>
              </div>
              <div className="ml-8 space-y-4">
                <p className="text-gray-700 leading-relaxed">
                  Nos reservamos el derecho de modificar estos términos y condiciones en cualquier momento. Las
                  modificaciones entrarán en vigor inmediatamente después de su publicación en este sitio web.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Es responsabilidad del cliente revisar periódicamente estos términos para mantenerse informado sobre
                  cualquier cambio.
                </p>
              </div>
            </section>

            {/* Sección 4 */}
            <section className="mb-8">
              <div className="flex items-center gap-3 mb-4 pb-2 border-b border-gray-100">
                <Mail className="h-5 w-5 text-gray-600" />
                <h2 className="text-lg font-semibold text-gray-900">4. Soporte Técnico y Contacto</h2>
              </div>
              <div className="ml-8 space-y-4">
                <p className="text-gray-700 leading-relaxed">
                  Para consultas técnicas, soporte o cualquier cuestión relacionada con estos términos, puede
                  contactarnos a través de:
                </p>
                <div className="bg-gray-50 border border-gray-200 rounded-lg p-4">
                  <p className="text-gray-700">
                    <strong>Email de soporte:</strong>{" "}
                    <a
                      href="mailto:maymasistemas@gmail.com"
                      className="font-medium hover:underline transition-colors"
                      style={{ color: "#77c593" }}
                    >
                      maymasistemas@gmail.com
                    </a>
                  </p>
                </div>
              </div>
            </section>
          </div>

          {/* Footer del documento */}
          <div className="border-t border-gray-200 bg-gray-50 px-8 py-4">
            <div className="flex justify-between items-center text-sm text-gray-600">
              <p>© {new Date().getFullYear()} Mayma. Todos los derechos reservados.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default terminosYCondiciones
